// src/pages/PricingPage.jsx
import { useNavigate } from 'react-router-dom';
import PricingPlans from '../components/PricingPlans';
import SEOHead from '../components/SEOHead';

export default function PricingPage() {
  const navigate = useNavigate();

  const handleSelectPlan = (planCode) => {
    console.log('✅ Plan seleccionado:', planCode);
    // Después de un pago exitoso, el componente PricingPlans redirige a /app
  };

  return (
    <>
      <SEOHead 
        title="Planes - Numerathum"
        description="Selecciona tu plan numerológico"
        noindex={true}
      />
      <PricingPlans onSelectPlan={handleSelectPlan} />
    </>
  );
}

